<script setup>
import { ref } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker, MarkerCluster } from "vue3-google-map";
import helpers from '@/Common/helpers';
import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiHandshakeOutline,
    mdiAccountGroupOutline,
    mdiShieldStarOutline,
    mdiTruckDeliveryOutline,
    mdiCableData,
    mdiCctv,
    mdiSend,
    mdiEmailFast

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    categoryChild: Object,
    categoryParent: Object,
    brands: Object
})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

const stocklabel = ref(false)



const marcas = ref(null)
marcas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/logos/acer.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/logos/amd.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/logos/apple.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/logos/asus.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/logos/cougar.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/logos/gigabyte.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/logos/HP.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/logos/intel.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/logos/lenovo.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/logos/lg.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/logos/nvidia.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/logos/samsung.png' }
]



// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

</script>

<template>
    <SeoMeta />
    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent">


        <!-- Modal -->
        <CardBoxModal v-model="isModalActive" title="Matrícula en línea">
            <p>Información del <b>padre de familia / apoderado</b></p>
            <!--<p>This is sample modal</p>-->
            <div>
                <BreezeLabel for="nombre" value="Nombre" />
                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.nombre" required autofocus autocomplete="name" />
            </div>
            <div class="mt-4">
                <BreezeLabel for="nivel" value="Nivel escolar" />
                <BreezeInput id="inicial" type="checkbox" class="mt-1 ml-2" v-model="form.inicial" required autocomplete="inicial" /> Inicial
                <BreezeInput id="primaria" type="checkbox" class="mt-1 ml-2" v-model="form.primaria" required autocomplete="primaria" /> Primaria
                <BreezeInput id="secundaria" type="checkbox" class="mt-1 ml-2" v-model="form.secundaria" required autocomplete="secundaria" /> Secundaria
            </div>
            <div class="mt-4">
                <BreezeLabel for="phone" value="Teléfono" />
                <BreezeInput id="phone" type="text" class="mt-1 block w-full" v-model="form.phone" required autocomplete="phone" />
            </div>
            <div class="mt-4">
                <BreezeLabel for="email" value="Email" />
                <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="mail" />
            </div>

            <div class="mt-4">
                <BreezeLabel for="comment" value="Comentario" />
                <BreezeInput id="comment" type="text" class="mt-1 block w-full" v-model="form.comment" required autocomplete="comment" />
            </div>
            <!--<div class="block mt-4">
                <label class="flex items-center">
                    <BreezeCheckbox name="remember" v-model:checked="form.recibirinfo" />
                    <span class="ml-2 text-sm text-gray-600">Recibir novedades?</span>
                </label>
            </div>-->
        </CardBoxModal>



        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/marcas/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Marcas que ofrecemos</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio / <span class="text-xs lg:text-sm font-normal">Marcas</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->

        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->

        <section>
            <div class=" mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-16">
                    <div class="col-span-1">
                        <div v-html="confGlobal.value.BRANDS_CONTENT_INTRODUCTION_PAGE" class="mb-8"></div>
                        <div>
                            <Link :href="route('eco-contactinfo')">
                            <button type="button" class="btn btn-color px-8 btn-ico">
                                <BaseIcon :path="mdiEmailFast" :size="20" class="mr-2" /> Contactanos
                            </button>
                            </Link>
                        </div>
                    </div>
                    <div class="col-span-1 h-full ">
                        <div class="h-full bg-[url('/img/empresa/marcas/01.jpg')] bg-no-repeat bg-center bg-cover min-h-[300px] lg:min-h-[400px]"></div>
                    </div>
                </div>
            </div>
        </section>

        <div class="mx-auto px-4 sm:px-6">
            <hr class=" my-6">
        </div>

        <section>
            <div class="mx-auto px-4 sm:px-6 py-12 lg:py-20">
                <div class="grid grid-cols-1">
                    <div class="col-span-1 mb-12">
                        <h1 class="sm:text-3xl text-xl font-600 leading-none text-center">Catálogo de marcas</h1>
                        <!-- <p class="mb-4 text-lg text-center"> Ofrecemos productos 100% originales con la mejor calidad y garantia
                        </p> -->
                    </div>
                </div>

                <div class="grid grid-cols-3 md:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7 justify-center gap-8 lg:gap-x-10 lg:gap-y-20 mb-10 lg:mb-12" v-if="brands.length > 0">
                    <div class="col-span-1 " v-for="(item, index) in brands" :key="item.id">
                        <Link :href="route('eco-product-category', { id: 0, label: '', originbrand: item.id })" class="">
                        <div class="border hover:border-2 hover:border-sky-500 rounded-md px-6 py-4 transition-transform ease-out duration-300 h-[158px]">
                            <div class="flex-col gap-6 hover:grayscale transition-all ease-in-out duration-500 ">
                                <div class="h-[100px] flex justify-center items-center">
                                    <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" class="w-full h-full  max-h-16 lg:max-h-20 object-contain">
                                </div>
                                <div class="flex justify-center limit-line line-1 !mb-0">
                                    <p class="text-base text-gray-800 font-semibold mb-0 text-center">{{ item.label }}</p>
                                </div>
                            </div>
                        </div>

                        </Link>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/marcas/call-action.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class="mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative">
                        <div class="grid-cols-1 grid lg:grid-cols-5">
                            <div class="col-span-1 lg:col-span-3 mb-6 lg:mb-0">
                                <h1 class="text-white text-[2.1em] mb-2">¿Tiene consultas? Podemos responderlas todas.</h1>
                                <p class="text-white text-sm lg:text-lg">Llámenos ahora al <a :href="'tel:' + confGlobal.value.COMPANY_PHONE" class="a-color-light font-semibold">{{ helpers.number2Phone(confGlobal.value.COMPANY_PHONE, 'fijo') }}</a> o
                                    escribanos a <a class="a-color-light font-semibold" :href="'mailto:' + confGlobal.value.COMPANY_MAIL" href="#">{{ confGlobal.value.COMPANY_MAIL }}</a>.<br>
                                    Podemos resolver esa consulta con una sola llamada, si es una consulta muy amplia agende ahora una reunión.</p>
                            </div>
                            <div class="col-span-1 lg:col-span-2 flex items-center justify-start lg:justify-center">
                                <Link type="button" class="btn btn-ico lg:btn-lg btn-color space-x-3" :href="route('eco-contactinfo')">
                                <BaseIcon :path="mdiSend" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                <span>Obtener más información</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
